import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export interface StackedBarSegment {
  label: string;
  value: number;
  colorVar: string;
}

@Component({
  selector: 'app-stacked-bar',
  templateUrl: './stacked-bar.component.html',
  styleUrl: './stacked-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StackedBarComponent {
  segments = input.required<StackedBarSegment[]>();
  height = input<number>(8);
  ariaLabel = input<string>('');

  protected readonly total = computed(() => this.segments().reduce((sum, segment) => sum + segment.value, 0));

  protected width(value: number): string {
    const total = this.total();
    if (total <= 0) return '0%';
    return `${(value / total) * 100}%`;
  }

  protected background(colorVar: string): string {
    return `var(${colorVar})`;
  }
}
